import { render } from "./TotalesProyectos.vue?vue&type=template&id=df689642"
import script from "./TotalesProyectos.vue?vue&type=script&lang=js"
export * from "./TotalesProyectos.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__